import { render, staticRenderFns } from "./MutationForm.vue?vue&type=template&id=38839e5d&scoped=true&"
import script from "./MutationForm.vue?vue&type=script&lang=ts&"
export * from "./MutationForm.vue?vue&type=script&lang=ts&"
import style0 from "./MutationForm.vue?vue&type=style&index=0&id=38839e5d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38839e5d",
  null
  
)

export default component.exports